import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { invoiceStatusFilterConfig } from '../../../configs/invoice-status-filter-config';

export const InvoiceStatusFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Status'
      config={invoiceStatusFilterConfig}
    />
  );
};
